import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandElastx({
    height = 28,
    width = 90,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-elastx-brand-logo'
                    : 'provider-elastx-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandElastx"
            width={width}
        />
    );
}

export default AppLogoBrandElastx;
